// Native implementation for filescanner API - replacing @filescannerApi/frontend-api

import { CheckFileUploadRequest, GetUploadedFileAsBase64Request, StringPrimitiveWrapper, UploadedFile } from './types'

export interface FileScannerConfiguration {
  basePath: string
  fetchApi: (input: RequestInfo, init?: RequestInit) => Promise<Response>
}

export class FileScannerApi {
  private configuration: FileScannerConfiguration

  constructor(configuration: FileScannerConfiguration) {
    this.configuration = configuration
  }

  /**
   * POST /rest/file_scanner
   * Upload a file for scanning
   */
  async checkFileUpload(request: CheckFileUploadRequest): Promise<StringPrimitiveWrapper> {
    const formData = new FormData()
    formData.append('file', request.file)
    formData.append('filename', request.filename)

    const response = await this.configuration.fetchApi(
      `${this.configuration.basePath}/rest/file_scanner`,
      {
        method: 'POST',
        body: formData
      }
    )

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }

    return await response.json()
  }

  /**
   * GET /rest/file_scanner/{uploadedFileId}
   * Get uploaded file as base64
   */
  async getUploadedFileAsBase64(request: GetUploadedFileAsBase64Request): Promise<UploadedFile> {
    const response = await this.configuration.fetchApi(
      `${this.configuration.basePath}/rest/file_scanner/${encodeURIComponent(request.uploadedFileId)}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }
    )

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }

    return await response.json()
  }
}
